import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex-center mt-2"
};
const _hoisted_2 = {
  class: "flex-1 flex flex-col items-end font-bold text-right"
};
const _hoisted_3 = {
  class: "flex items-center"
};
const _hoisted_4 = {
  class: "flex-center flex-col"
};
const _hoisted_5 = {
  key: 0,
  class: "flex-center text-xs"
};
const _hoisted_6 = {
  class: "flex-center"
};
const _hoisted_7 = {
  class: "w-8 text-right"
};
const _hoisted_8 = {
  class: "font-bold"
};
const _hoisted_9 = /*#__PURE__*/_createTextVNode("-");
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-lg px-1"
}, ":", -1);
const _hoisted_11 = {
  class: "w-8"
};
const _hoisted_12 = {
  class: "font-bold text-left"
};
const _hoisted_13 = /*#__PURE__*/_createTextVNode("-");
const _hoisted_14 = {
  key: 0,
  class: "flex-center flex-col"
};
const _hoisted_15 = {
  class: "flex-center"
};
const _hoisted_16 = {
  class: "w-8 text-2xl text-right"
};
const _hoisted_17 = {
  class: "font-bold"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-lg px-1"
}, ":", -1);
const _hoisted_19 = {
  class: "w-8 text-2xl"
};
const _hoisted_20 = {
  class: "font-bold text-left"
};
const _hoisted_21 = {
  class: "flex-center"
};
const _hoisted_22 = {
  key: 0,
  class: "text-xs text-slate-700"
};
const _hoisted_23 = {
  key: 1,
  class: "text-xs text-slate-700"
};
const _hoisted_24 = {
  class: "flex-1 flex flex-col items-start font-bold text-left"
};
const _hoisted_25 = {
  class: "flex items-center"
};
import { CardIncident } from "@/modules/match/entity";
import { app } from "@/di";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import EffectiveLineupSkillCalculator from "@/modules/team/services/EffectiveLineupSkillCalculator";
import { CardEnum } from "@/modules/match/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchScore',
  props: {
    match: null,
    incidents: null,
    minute: null
  },
  setup(__props) {
    const props = __props;
    const started = computed(() => Number.isInteger(props.match.homeGoals));
    const effectiveLineupSkillCalculator = app.get(EffectiveLineupSkillCalculator);
    const homeSkill = computed(() => {
      if (!props.incidents) {
        return props.match.homeSkill;
      }
      return effectiveLineupSkillCalculator.calculateLinedupSkillByTeam(props.match.homeTeam, props.match.homeTeam.players.filter(p => p.lineup !== null).filter(p => !props.incidents.find(i => i.playerId === p.id && i instanceof CardIncident && [CardEnum.YELLOW_RED, CardEnum.RED].includes(i.card))));
    });
    const awaySkill = computed(() => {
      if (!props.incidents) {
        return props.match.awaySkill;
      }
      return effectiveLineupSkillCalculator.calculateLinedupSkillByTeam(props.match.awayTeam, props.match.awayTeam.players.filter(p => p.lineup !== null).filter(p => !props.incidents.find(i => i.playerId === p.id && i instanceof CardIncident && [CardEnum.YELLOW_RED, CardEnum.RED].includes(i.card))));
    });
    return (_ctx, _cache) => {
      const _component_NTag = _resolveComponent("NTag");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(EntityLink, {
        entity: __props.match.homeTeam,
        disabled: "",
        orientation: "right",
        class: "mb-2 text-xs"
      }, null, 8, ["entity"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_NTag, {
        type: "default",
        secondary: "",
        round: "",
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(started) ? __props.match.homeFormation : __props.match.homeTeam.formation), 1)]),
        _: 1
      }), _unref(started) ? (_openBlock(), _createBlock(_component_NTag, {
        key: 0,
        type: "primary",
        secondary: "",
        round: "",
        size: "small",
        class: "ml-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(Math.round(_unref(homeSkill))), 1)]),
        _: 1
      })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: _normalizeClass(["flex-center flex-col", {
          'text-2xl': !__props.match.penalty
        }])
      }, [__props.minute ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('x_minute', {
        minute: __props.minute
      })), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_unref(started) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(__props.match.homeGoals - __props.match.homePenaltyGoals), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_9], 64))])]), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_unref(started) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(__props.match.awayGoals - __props.match.awayPenaltyGoals), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_13], 64))])])])], 2), __props.match.penalty ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(__props.match.homePenaltyGoals), 1)]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(__props.match.awayPenaltyGoals), 1)])]), _createElementVNode("div", _hoisted_21, [__props.match.penalty ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('penalty_time_short')), 1)) : __props.match.extraTime ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('extra_time_short')), 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_createVNode(EntityLink, {
        entity: __props.match.awayTeam,
        disabled: "",
        class: "mb-2 text-xs"
      }, null, 8, ["entity"]), _createElementVNode("div", _hoisted_25, [_unref(started) ? (_openBlock(), _createBlock(_component_NTag, {
        key: 0,
        type: "primary",
        secondary: "",
        round: "",
        size: "small",
        class: "mr-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(Math.round(_unref(awaySkill))), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_NTag, {
        type: "default",
        secondary: "",
        round: "",
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(started) ? __props.match.awayFormation : __props.match.awayTeam.formation), 1)]),
        _: 1
      })])])]);
    };
  }
});